// Task #263 — shared empty state for the Agent Profile "Assessment
// performance" panel. Replaces the previous pair of stacked dashed
// boxes ("No assessments graded in this period." +
// "No assessment results in this period.") plus the duplicate
// "Based on 0 calls in your scope" caption with a single friendlier
// empty state that sits inside the panel using the app's standard
// soft surface styling (no dashed borders).
import type { ReactNode } from "react";
import { Inbox } from "lucide-react";

export function AssessmentEmptyState({
  icon,
  headline,
  subline,
  actionLabel,
  onAction,
}: {
  icon?: ReactNode;
  headline: string;
  subline?: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  const showAction = !!actionLabel && typeof onAction === "function";
  return (
    <div
      className="flex flex-col items-center justify-center text-center rounded-lg bg-muted/30 px-6 py-10"
      data-testid="assessment-empty-state"
    >
      <div
        className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground"
        aria-hidden="true"
      >
        {icon ?? <Inbox className="h-5 w-5" />}
      </div>
      <div className="mt-3 text-sm font-semibold text-foreground">
        {headline}
      </div>
      {subline ? (
        <p className="mt-1 max-w-md text-xs text-muted-foreground">
          {subline}
        </p>
      ) : null}
      {showAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 inline-flex items-center gap-1.5 rounded-md border border-input bg-card px-3 py-1.5 text-xs font-medium text-foreground hover:bg-muted/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
